export default __webpack_public_path__ + "static/media/Aura-Egg__37.a5bf927e.png";